import { Box, HStack, Text, VStack, Stack } from '@chakra-ui/react'
import LessonBreadcrumb from 'shared/pages/lessonPage/LessonBreadcrumb'
import { FC, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as IconChevronLeft } from 'shared/assets/bsChevronLeft.svg'
import { IEntity, IEntityType } from 'shared/types'
import EditSectionButton from 'shared/components/EditSectionButton'

type Props = {
  title: string
  backUrl: string
  children?: ReactNode
  entity: IEntity
  entityType: IEntityType
  weekId?: string
  dayId?: string
  lessonId?: string
  onEditHeader?: () => void
}

const LessonHeader: FC<Props> = ({
  title,
  backUrl,
  children,
  entity,
  entityType,
  weekId,
  dayId,
  lessonId,
  onEditHeader
}) => {
  const navigate = useNavigate()
  return (
    <VStack
      w='full'
      pt={{ base: 14, lg: '72px' }}
      spacing={{ base: 6, lg: 6 }}
      pb={{ base: 4, lg: 8 }}
    >
      <EditSectionButton onClick={onEditHeader} />
      <LessonBreadcrumb
        entity={entity}
        entityType={entityType}
        weekId={weekId}
        dayId={dayId}
        lessonId={lessonId}
      />
      <Stack
        w='full'
        direction={{ base: 'column', lg: 'row' }}
        align={{ base: 'flex-end', lg: 'flex-end' }}
        justify={{ base: 'flex-start', lg: 'space-between' }}
      >
        <HStack w='full' spacing={2}>
          <Box as='button' onClick={() => navigate(backUrl)}>
            <IconChevronLeft color='black.500' width={24} />
          </Box>
          <Text textStyle='h2' fontWeight={700}>
            {title}
          </Text>
        </HStack>
        {children}
      </Stack>
    </VStack>
  )
}

export default LessonHeader
